import { createContext, useContext } from 'react';
import { useSolutionList } from './hooks/useSolutionList';

const SolutionContext = createContext();

function SolutionProvider({ children }) {
  const {
    isPending: solutionListIsLoading,
    isError: solutionListHasError,
    error,
    solution,
  } = useSolutionList();

  return (
    <SolutionContext.Provider
      value={{
        solutionListIsLoading,
        solutionListHasError,
        errorCode: error?.status || -1,
        solution,
      }}
    >
      {children}
    </SolutionContext.Provider>
  );
}

function useSolutionContext() {
  const context = useContext(SolutionContext);

  if (context === undefined) {
    throw new Error('SolutionContext must be used within a SolutionProvider');
  }
  return context;
}

export { SolutionProvider, useSolutionContext };
